import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import {
  BalanceResponse,
  PaymentSummary,
  TransactionsResponse,
  WalletTransactionParams,
} from "type/wallet";

export const wallet = createApi({
  reducerPath: "wallet",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getWalletBalance: builder.query<BalanceResponse, void>({
      query: () => ({
        url: `wallets/balance`,
        method: "GET",
      }),
    }),
    getWalletTransaction: builder.query<
      TransactionsResponse,
      WalletTransactionParams
    >({
      query: ({ startDate, endDate, page }) => ({
        url: `wallets/transactions?startDate=${startDate}&endDate=${endDate}&page=${page}`,
        method: "GET",
      }),
    }),
    walletCheckout: builder.mutation<any, PaymentSummary>({
      query: (body) => ({
        url: `wallets/checkout`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetWalletBalanceQuery,
  useWalletCheckoutMutation,
  useGetWalletTransactionQuery,
} = wallet;
